import React, { useState, useEffect } from "react";
import { db } from "../../firebase";
import css from "./adm.module.css";
import {
  collection,
  getDocs,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

const storage = getStorage();
const objList = [
  {
    name: "ISBN",
    transliter: "ISBN",
  },
  {
    name: "СЕО Имя літопису",
    transliter: "ceoName",
  },
  {
    name: "Назва літопису",
    transliter: "bookName",
  },
  {
    name: "Прізвисько літопису",
    transliter: "prizvusko",
  },
  {
    name: "Серія",
    transliter: "seria",
  },
  {
    name: "Автор тексту",
    transliter: "textAutor",
  },
  {
    name: "Художник",
    transliter: "picWriter",
  },
  {
    name: "Автор ідеї",
    transliter: "autorIdea",
  },
  {
    name: "Перекладач",
    transliter: "bookTranslater",
  },
  {
    name: "Редактор",
    transliter: "bRedaktor",
  },

  {
    name: "Психологічна експертиза",
    transliter: "psExpert",
  },
  {
    name: "Мовознавча експертиза",
    transliter: "lnExpert",
  },
  {
    name: "Дизайн",
    transliter: "bDesign",
  },
  {
    name: "Над макетом працювали",
    transliter: "onMakWork",
  },
  {
    name: "вид продукту",
    transliter: "prodType",
  },

  {
    name: "Палітурка",
    transliter: "paliturka",
  },
  {
    name: "Кількість сторінок",
    transliter: "pageCount",
  },
  {
    name: "формат (мм)",
    transliter: "bookFormat",
  },
  {
    name: "Товщина (мм)",
    transliter: "booksH",
  },
  {
    name: "Вага (гр)",
    transliter: "booksWei",
  },
  {
    name: "Рік видання",
    transliter: "bookYear",
  },
  {
    name: "Мова видання",
    transliter: "bookLanguage",
  },
  {
    name: "Папір",
    transliter: "bookPaper",
  },
  {
    name: "Ілюстрації",
    transliter: "ilystracii",
  },
  {
    name: "Підбірки книг",
    transliter: "pidbirkuBoo",
  },

  {
    name: "Категрорія за об'ємом",
    transliter: "priceMas",
  },
  {
    name: "Навантаження текстом",
    transliter: "moreText",
  },
  {
    name: "Любов до читання",
    transliter: "readLove",
  },
  {
    name: "Вікова група",
    transliter: "yearGroup",
  },
  {
    name: "Жанр",
    transliter: "ganr",
  },
  {
    name: "Спосіб взаємодії",
    transliter: "metVzaem",
  },
  {
    name: "За призначенням",
    transliter: "forWho",
  },
  {
    name: "Комплектація книги",
    transliter: "complectation",
  },
  {
    name: "Книжкові відзнаки",
    transliter: "vidznaku",
  },
  {
    name: "Популярність",
    transliter: "popular",
  },

  {
    name: "Герої книги",
    transliter: "bookHero",
  },
  {
    name: "Дивіз",
    transliter: "duviz",
  },
  {
    name: "Сила книги",
    transliter: "bookPower",
  },
  {
    name: "фото",
    transliter: "bookFoto",
  },
  {
    name: "фото розгорток",
    transliter: "fotoRozgort",
  },

  {
    name: "Короткий опис",
    transliter: "smallDesc",
  },
  {
    name: "Середній опис",
    transliter: "descriptionSe",
  },
  {
    name: "Відгук експерта",
    transliter: "expert",
  },
  {
    name: "Відгук читача",
    transliter: "respUser",
  },
  {
    name: "Довгий опис",
    transliter: "longDesk",
  },
  {
    name: "цитати з книги",
    transliter: "bookChu",
  },
  {
    name: "Ceo title",
    transliter: "ceoTitle",
  },
  {
    name: "Ceo description",
    transliter: "coeDescription",
  },
  {
    name: "Ceo keyWord",
    transliter: "coekeyWord",
  },
  {
    name: "Новинка",
    transliter: "novunka",
  },
  {
    name: "скорочений PDF",
    transliter: "shortPdf",
  },
  {
    name: "повний PDF",
    transliter: "longPdf",
  },
];
const ManuscriptListEditor = () => {
  const [manuscripts, setManuscripts] = useState([]);
  const [editedManuscript, setEditedManuscript] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const snapshot = await getDocs(collection(db, "manuscript"));
    const docs = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    setManuscripts(docs);
  };

  const handleEdit = (m) => setEditedManuscript({ ...m });

  const handleSave = async () => {
    if (editedManuscript) {
      const ref = doc(db, "manuscript", editedManuscript.uid);
      await updateDoc(ref, editedManuscript);
      setEditedManuscript(null);
      fetchData();
    }
  };

  const handleCancel = () => setEditedManuscript(null);

  const handleChange = (field, value, index) => {
    if (index !== undefined) {
      const updatedArray = [...editedManuscript[field]];
      updatedArray[index] = value;
      setEditedManuscript((prev) => ({ ...prev, [field]: updatedArray }));
    } else {
      setEditedManuscript((prev) => ({ ...prev, [field]: value }));
    }
  };

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, "manuscript", id));
    fetchData();
  };

  const handleNewMessage = (e, field) => {
    e.preventDefault();
    setEditedManuscript((prev) => ({
      ...prev,
      [field]: prev[field] ? [...prev[field], ""] : [""],
    }));
  };

  const handleRemoveItem = (field, index) => {
    setEditedManuscript((prev) => {
      const updatedArray = [...prev[field]];
      updatedArray.splice(index, 1);
      return { ...prev, [field]: updatedArray };
    });
  };

  const uploadFile = async (file, pathPrefix) => {
    const storageRef = ref(storage, `${pathPrefix}/${file.name}`);
    await uploadBytes(storageRef, file);
    return await getDownloadURL(storageRef);
  };

  return (
    <div className={css.divForList}>
      <h1>Список рукописів</h1>
      <ul className={css.ulHer}>
        {manuscripts.map((m, i) => (
          <li key={m.uid} className={css.listLiProd}>
            <p>
              {i + 1}. {m.bookName}
            </p>
            <button onClick={() => handleEdit(m)}>Редагувати</button>
            <button onClick={() => handleDelete(m.uid)}>Видалити</button>
          </li>
        ))}
      </ul>

      {editedManuscript && (
        <div>
          <h2>Редагування рукопису</h2>
          {objList.map((obj) => (
            <div key={obj.transliter}>
              <label>{obj.name}</label>

              {["bookFoto", "shortPdf", "longPdf"].includes(obj.transliter) ? (
                <>
                  {editedManuscript[obj.transliter] && (
                    <div style={{ marginBottom: "8px" }}>
                      <a
                        href={editedManuscript[obj.transliter]}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Переглянути файл
                      </a>
                    </div>
                  )}
                  <input
                    type="file"
                    accept={obj.transliter === "bookFoto" ? "image/*" : ".pdf"}
                    onChange={async (e) => {
                      const file = e.target.files[0];
                      if (file) {
                        const url = await uploadFile(file, obj.transliter);
                        setEditedManuscript((prev) => ({
                          ...prev,
                          [obj.transliter]: url,
                        }));
                      }
                    }}
                  />
                </>
              ) : Array.isArray(editedManuscript[obj.transliter]) ||
                typeof editedManuscript[obj.transliter] === "undefined" ? (
                <>
                  {(editedManuscript[obj.transliter] || []).map((val, idx) => (
                    <div key={`${obj.transliter}-${idx}`}>
                      <input
                        type="text"
                        value={val || ""}
                        onChange={(e) =>
                          handleChange(obj.transliter, e.target.value, idx)
                        }
                      />
                      <button
                        type="button"
                        onClick={() => handleRemoveItem(obj.transliter, idx)}
                      >
                        Видалити
                      </button>
                    </div>
                  ))}
                  <button
                    type="button"
                    onClick={(e) => handleNewMessage(e, obj.transliter)}
                  >
                    Додати елемент
                  </button>
                </>
              ) : (
                <input
                  type="text"
                  value={editedManuscript[obj.transliter] || ""}
                  onChange={(e) => handleChange(obj.transliter, e.target.value)}
                />
              )}
            </div>
          ))}
          <button onClick={handleSave}>Зберегти</button>
          <button onClick={handleCancel}>Скасувати</button>
        </div>
      )}
    </div>
  );
};

export default ManuscriptListEditor;
